var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5597 18.7769C24.5597 18.7769 18.5862 28.4627 13.6888 28.4627C5.12251 28.4627 13.1056 10.0108 19.3533 10.0108C23.7128 10.0108 24.5597 18.7769 24.5597 18.7769V18.7769Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6578 30.9579C29.9561 32.7687 27.8558 34.1582 25.5235 35.0162C23.1912 35.8742 20.6911 36.1772 18.2213 35.901C15.7516 35.6248 13.3801 34.7771 11.295 33.4252C9.20996 32.0732 7.46858 30.2541 6.20898 28.1122C7.62512 30.0382 10.027 31.3223 13.4424 31.3223C21.8559 31.3223 26.6319 24.7841 26.6319 24.7841C26.6319 24.7841 27.045 29.9515 31.6474 30.9579H31.6578Z",
    fill: "#FF6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1778 12.5962C35.4371 15.0023 36.0625 17.6894 35.9951 20.4041C35.9277 23.1188 35.1697 25.7716 33.7925 28.1122C32.7033 27.5013 31.898 26.4867 31.5503 25.2873L29.7246 19.818L34.1778 12.5962V12.5962Z",
    fill: "#FF6600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0025 4.0139C24.0148 4.01123 27.881 5.51905 30.8318 8.23732L27.8017 13.1271C26.7049 10.2744 24.4765 7.41832 20.1414 7.41832C11.2627 7.41832 4.68185 17.1111 4.68185 23.1877C4.67989 23.9735 4.78023 24.7563 4.98034 25.5163C4.09247 23.098 3.80164 20.5012 4.13257 17.9465C4.46351 15.3918 5.40642 12.9547 6.88117 10.8424C8.35593 8.73016 10.3189 7.00507 12.6033 5.81381C14.8878 4.62254 17.4261 4.00031 20.0025 4V4.0139Z",
    fill: "#FF6600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.f9c52378fd3a108cfb3eb29fbdb40802.svg";
export { ForwardRef as ReactComponent };